/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress, makeStyles, Tooltip } from "@material-ui/core";
import Swal from "sweetalert2";

import NewDepartment from "./NewDepartment";

import { getRequest } from "utils/request";

import { putRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { translate } from "translate/i18n";
import { useModal } from "hooks/modal";
import exportExcel from "utils/exportExcel";
import formatDate from "utils/formatDate";

const usersTemplate = (data) => {
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      {data.UserCompanies.map((userC) => (
        <Tooltip title={userC.User.nickName}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="2" />
            <circle cx="12" cy="10" r="4" fill="black" />
            <path
              d="M6 18C6 15.7909 7.79086 14 10 14H14C16.2091 14 18 15.7909 18 18"
              stroke="black"
              strokeWidth="2"
            />
          </svg>
        </Tooltip>
      ))}
    </div>
  );
};

export default function TabDepartments({ companyData, handleUpdate, match }) {
  const [department, setDepartment] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newDepartment, setNewDepartment] = useState(false);
  const [filter, setFilter] = useState("");
  const [onlyActive, setOnlyActive] = useState(true);
  const [selectedDepartment, setSelectedDepartment] = useState({});
  const { toggleHelperId } = useModal();

  const useStyles = makeStyles((theme) => ({
    customWidth: {
      fontSize: 16,
    },
  }));
  const classes = useStyles();

  const getCompanyDepartments = () => {
    setLoading(true);
    getRequest(
      `/companiesdepartments/bycompany?CompanyId=${companyData.id}&onlyActive=${
        onlyActive ? 1 : 0
      }`
    ).then(function (response) {
      console.log("companiesdepartments/bycompany response", response);
      response.data.forEach((e) => {
        if (e.active === true) {
          e.active = translate("userActive");
        } else {
          e.active = translate("inactive");
        }
      });
      setDepartment(response.data);
      setLoading(false);
    });
  };

  const handleGoBack = () => {
    setNewDepartment(!newDepartment);
  };

  const handleNewDepartment = () => {
    handleUpdate(13);
    setNewDepartment(!newDepartment);
  };

  const handleEditDepartment = (data) => {
    setSelectedDepartment(data);
    setNewDepartment(!newDepartment);
  };

  const handleSetInactive = (id) => {
    Swal.fire({
      title: translate("attemption"),
      text: translate("deleteDepartment"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: translate("confirmEraseCompany"),
    }).then((result) => {
      if (result.isConfirmed) {
        putRequest(`/companiesdepartments/inactivate/${id}`).then(function (
          response
        ) {
          handleUpdate(13);
        });
      }
    });
  };

  const handleNew = () => {
    setSelectedDepartment({});
    setNewDepartment(true);
  };

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          className="action-icon"
          style={{
            cursor: "pointer",
            marginRight: 10,
            display: data.active === "Ativo" ? "visible" : "none",
          }}
          onClick={() => handleEditDepartment(data)}
        >
          <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
        </div>
        {data.default ? (
          <Tooltip
            arrow
            classes={{ tooltip: classes.customWidth }}
            title={translate("departmentDefaultDeleteInformMessage")}
          >
            <button
              className="action-icon"
              style={{
                cursor: "pointer",
                background: "transparent",
                border: "none",
                opacity: "20%",
              }}
            >
              <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
            </button>
          </Tooltip>
        ) : (
          <button
            className="action-icon"
            disabled={!data.active}
            style={{
              cursor: "pointer",
              background: "transparent",
              border: "none",
              display: data.active === "Ativo" ? "visible" : "none",
            }}
            onClick={() => handleSetInactive(data.id)}
          >
            <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
          </button>
        )}
      </div>
    );
  };

  const header = (
    <div className="data-table-header" style={{ position: "relative" }}>
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: -16 }}
      >
        <input
          checked={onlyActive}
          onChange={() => setOnlyActive(!onlyActive)}
          type="checkbox"
          className="checkbox"
          style={{ marginRight: 10 }}
        />
        <label>{translate("showInactive")}</label>
      </div>
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: 0 }}
      ></div>
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        onChange={(e) => setFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  );

  useEffect(() => {
    toggleHelperId(!newDepartment ? 47 : 48);
  }, [newDepartment]);

  useEffect(() => {
    getCompanyDepartments();
    setFilter("");
  }, [onlyActive]);

  const handleExport = () => {
    let data = [];

    department.forEach((e) => {
      const userTypeAux = {
        Id: e.id,
        [translate("description")]: e.description,
        [translate("createdAt")]: formatDate(e.createdAt),
        [translate("userActive")]: e.active,
      };

      data.push(userTypeAux);
    });

    exportExcel(data, translate("clientsTypes"));
  };

  const departmentTemplate = (data) => {
    return <>{data.default ? "Sim" : "Não"}</>;
  };

  return (
    <div className="list-container">
      <div
        className="title-helper-container"
        style={{
          marginBottom: newDepartment && 10,
          borderWidth: !newDepartment && 0,
        }}
      >
        <h3>{companyData.nickName}</h3>
        {!newDepartment && (
          <button
            style={{ marginBottom: 5 }}
            type="button"
            onClick={handleExport}
            className="export-excel"
          >
            <i
              style={{ fontSize: 16, marginRight: 5 }}
              className="pi pi-file-excel"
            />
            <span style={{ fontSize: "1vw" }}>
              {translate("exportAllData")}
            </span>
          </button>
        )}
      </div>
      {!newDepartment ? (
        <>
          <div className="tab-content">
            <div className="tab-pane show active" id="multi-item-preview">
              {!loading ? (
                <DataTable
                  dataKey="id"
                  globalFilter={filter}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  value={department}
                  header={header}
                  paginator
                  rows={5}
                  emptyMessage={translate("noUserTypeFinded")}
                >
                  <Column
                    field="description"
                    header={translate("description")}
                    sortable
                  ></Column>
                  <Column
                    body={departmentTemplate}
                    header={translate("defaultDepartment")}
                    sortable
                  ></Column>
                  <Column
                    body={usersTemplate}
                    header={translate("members")}
                    field="UserCompanies"
                  ></Column>
                  <Column
                    field="active"
                    header={translate("status")}
                    sortable
                  ></Column>
                  <Column
                    body={actionButtonsTemplate}
                    field="action"
                    header={translate("action")}
                  ></Column>
                </DataTable>
              ) : (
                <div className="area-loading">
                  <CircularProgress />
                </div>
              )}
            </div>
          </div>
          <div className="button-add-relative" onClick={() => handleNew()}>
            <i className="mdi mdi-plus"></i>
          </div>
        </>
      ) : (
        <NewDepartment
          handleNewDepartment={handleNewDepartment}
          companyId={companyData.id}
          selectedDepartment={selectedDepartment}
          handleGoBack={handleGoBack}
        />
      )}
    </div>
  );
}
